import Fuse from 'fuse.js';
import { useMemo } from 'react';
import { intersection } from 'lodash';
export function useFuseSearch(fuseOptions, items, search) {
    var fuse = useMemo(function () { return new Fuse(items || [], fuseOptions); }, [
        fuseOptions,
        items,
    ]);
    return useMemo(function () {
        if (!items || !search)
            return items;
        var terms = search.split(/\s+/g).filter(Boolean);
        var results = terms.map(function (term) { return fuse.search(term).map(function (x) { return x.item; }); });
        return intersection.apply(void 0, results);
    }, [items, search, fuse]);
}
//# sourceMappingURL=useFuseSearch.js.map